// Cálculo del turno de producción en cadenas Antelope.
// El tiempo se divide en slots de 500 ms (uno por bloque) desde el 1-1-2000.
// Cada productor del schedule produce 12 bloques seguidos (6 s), en el orden
// del schedule. Así que con la hora basta para saber a quién le toca.

const BLOCK_MS = 500;
const EPOCH_MS = 946684800000; // 2000-01-01T00:00:00Z
export const BLOCKS_PER_TURN = 12;

export const slotAt = (ms) => Math.floor((ms - EPOCH_MS) / BLOCK_MS);

/**
 * Turno actual para un schedule de `n` productores en el instante `ms`.
 * → { index (0-based), block (1..12), msLeftInTurn }
 */
export const turnAt = (n, ms) => {
  const slot = slotAt(ms);
  const turn = Math.floor(slot / BLOCKS_PER_TURN);
  const posInTurn = slot % BLOCKS_PER_TURN;
  const msIntoSlot = (ms - EPOCH_MS) % BLOCK_MS;
  return {
    index: turn % n,
    block: posInTurn + 1,
    msLeftInTurn: (BLOCKS_PER_TURN - posInTurn) * BLOCK_MS - msIntoSlot
  };
};

// Milisegundos hasta que empiece el turno del productor `i` (0 si le toca ya)
export const msUntilTurn = (i, n, ms) => {
  const { index, msLeftInTurn } = turnAt(n, ms);
  if (i === index) return 0;
  const turnsAhead = (i - index + n) % n; // ≥ 1
  return msLeftInTurn + (turnsAhead - 1) * BLOCKS_PER_TURN * BLOCK_MS;
};

// 7 → "7s", 75 → "1m 15s", 3700 → "1h 01m"
export const formatDuration = (ms) => {
  const s = Math.max(0, Math.ceil(ms / 1000));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m ${String(s % 60).padStart(2, '0')}s`;
  return `${Math.floor(s / 3600)}h ${String(Math.floor((s % 3600) / 60)).padStart(2, '0')}m`;
};

// Cambios entre dos schedules: quién entra y quién sale
export const diffSchedules = (prev, next) => ({
  added: next.filter((p) => !prev.includes(p)),
  removed: prev.filter((p) => !next.includes(p))
});

/**
 * Estado de un productor respecto al schedule.
 * rank: posición por votos (1-based) · inSchedule · isTelos (rotación de standbys)
 * → 'in_schedule' | 'rotated_out' | 'rotated_in' | 'standby' | 'not_in_schedule' | 'extra_in_schedule'
 */
export const scheduleStatus = ({ rank, inSchedule, isTelos, topN = 21 }) => {
  if (inSchedule) {
    if (rank > topN) return isTelos ? 'rotated_in' : 'extra_in_schedule';
    return 'in_schedule';
  }
  if (rank <= topN) return isTelos ? 'rotated_out' : 'not_in_schedule';
  return 'standby';
};
